import { IconButton, styled } from '../../../base';
import { shouldForwardProp } from '@mui/system';

const customShouldForwardProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) &&
    !['borderColor', 'iconColor'].includes(prop as string);

export const StyledIconButton = styled(IconButton, {
    shouldForwardProp: customShouldForwardProp,
})<{ borderColor: string }>(({ theme, borderColor }) => ({
    border: '2px solid',
    borderColor: borderColor,
    marginInlineEnd: theme.spacing(1),
    width: '40px',
    height: '40px',

    '&:hover': {
        backgroundColor: theme.palette.background.mainBackground, // Background color on hover
        borderColor: borderColor,
    },
}));
